<template>
  <div>
    <header-section :title='"Dịch vụ"'></header-section>
    <service-info></service-info>
  </div>
</template>
<script>
  import HeaderSection from "./components/Common/HeaderSection.vue";
  import ServiceInfo from "./components/Services/ServiceInfo.vue";
  export default{
    components:{
      HeaderSection,
      ServiceInfo
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/Services.vue